import {useMutation} from '@apollo/react-hooks';

import type {
    CheckDomain as CheckDomainMutation,
    CheckDomainVariables as CheckDomainMutationVariables,
    DomainCheckInput,
} from 'nutshell-graphql-types';

import CHECK_DOMAIN from '../mutations/check-domain.graphql';
import GET_DOMAINS from '../queries/get-domains.graphql';

export function useCheckDomain(): {
    checkDomain: (arg1: DomainCheckInput) => Promise<any>;
    isChecking: boolean;
} {
    const [checkDomain, {loading}] = useMutation<CheckDomainMutation, CheckDomainMutationVariables>(
        CHECK_DOMAIN
    );

    return {
        checkDomain: (input: DomainCheckInput) =>
            checkDomain({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const updatedDomain =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.domainCheck &&
                        mutationResults.data.domainCheck.domain;

                    const cacheResult = proxy.readQuery({
                        query: GET_DOMAINS,
                    });

                    if (cacheResult && updatedDomain) {
                        proxy.writeQuery({
                            query: GET_DOMAINS,
                            data: {
                                // @ts-expect-error
                                domains: cacheResult.domains.map((domain) =>
                                    domain.id === updatedDomain.id ? updatedDomain : domain
                                ),
                            },
                        });
                    }
                },
            }),
        isChecking: loading,
    };
}
